<template>
  <div class="vod-series">
    <ul>
      <li
        v-for="(cell, index) in cellList"
        :key="`series_cell_${index}`"
      >
        <SeriesLandscapeCell
          :cell-info="cell"
          :thumbnail-info="thumbnailInfo"
          @click-fn="selectCell(cell)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import SeriesLandscapeCell from '@/components/play/bottom-tab/SeriesLandscapeCell'

export default {
  name: 'VodEpisodeCellList',
  components: {
    SeriesLandscapeCell
  },
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    },
    containerClassName: {
      type: String
    },
    contentInfo: {
      type: Object
    }
  },
  methods: {
    selectCell (cell) {
      const url = `player/vod?contentid=${cell.contentid}`
      utils.common.checkInstallApps(url)
    }
  }
}
</script>
